import React from "react";
import { useSelector } from "react-redux";
import { getUserRole } from "@icarius-app/selectors";
import { DialogActions, Typography, TextField } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import TextEditor from "@icarius-common/textEditor";
import LinkDownloadPollItem from "@icarius-pages/feed/components/form/components/linkDownloadPollItem";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import {
    createCommunicationChannelAction,
    updateCommunicationChannelAction,
} from "@icarius-pages/communicationChannel/actions";
import FileInput from "./components/fileInput";
import useHandleForm from "./useHandleForm";
import { getLocalizedString } from "@icarius-localization/strings";

const Form = (props) => {
    const { type, typeString, data, handleClose } = props;

    const dispatch = useDispatch();
    const level = useSelector(getUserRole);

    const create = (dataToSend) => {
        dispatch(createCommunicationChannelAction(dataToSend)).then((res) => {
            if (res?.status === 200 && handleClose) {
                dispatch(
                    openSnackbarAction({
                        msg:
                            type !== "D"
                                ? `${getLocalizedString("thanksForSharingYour")} ${typeString} ${getLocalizedString(
                                      "communicationChannelMessageCreated"
                                  )}`
                                : getLocalizedString("thankYouForReporting"),
                        severity: "success",
                        duration: null,
                    })
                );
                handleClose();
            }
        });
    };

    const update = (dataToSend) => {
        dispatch(updateCommunicationChannelAction(dataToSend)).then((res) => {
            if (res?.status === 200 && handleClose) {
                dispatch(
                    openSnackbarAction({
                        msg: `${getLocalizedString("your")} ${typeString} ${getLocalizedString(
                            "communicationChannelMessageModified"
                        )}`,
                        severity: "success",
                        duration: 10000,
                    })
                );
                handleClose();
            }
        });
    };

    const openValidationError = () => {
        dispatch(
            openSnackbarAction({
                msg: getLocalizedString("mustEnterCommunicationComment"),
                severity: "error",
                duration: 10000,
            })
        );
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(data, create, update, openValidationError, type);

    const submitButtonText = (() => {
        if (!isCreate) return getLocalizedString("save");
        return getLocalizedString("submit");
    })();

    return (
        <>
            <>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    <Typography className="whiteText">
                        {type === "T"
                            ? getLocalizedString("commentRelatedWithThirdPartyReport")
                            : `${getLocalizedString("commentRelatedWith")} ${typeString}: `}
                    </Typography>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10, marginTop: 10 }}>
                    <div style={{ flex: 1, minWidth: 200 }}>
                        <TextEditor
                            initialValue={isCreate ? "" : data.comment}
                            placeholder={getLocalizedString("enterComment")}
                            handleChange={(value) => setFormValue(value, "comment")}
                        />
                    </div>
                </div>
            </>
            {Boolean(formData.attachment) && (
                <div style={{ marginTop: 10 }}>
                    <LinkDownloadPollItem
                        handleDelete={() => setFormValue(null, "attachment")}
                        data={formData.attachment}
                        type="file"
                    />
                </div>
            )}
            <DialogActions style={{ justifyContent: "space-between", alignItems: "flex-end", marginTop: 10 }}>
                {level === "E" && (
                    <div style={{ flex: 1, marginRight: 20 }}>
                        <TextField
                            fullWidth
                            margin={"none"}
                            label={getLocalizedString("thirdPartyReportNameSurname")}
                            value={formData.name}
                            onChange={(e) => setFormValue(e.target.value, "name")}
                            inputProps={{ maxLength: 80 }}
                        />
                    </div>
                )}
                <div style={{ display: "flex", alignItems: "center", marginLeft: level !== "E" ? "auto" : 0 }}>
                    <div style={{ marginRight: 10 }}>
                        <FileInput isCreate={isCreate} handleChange={(value) => setFormValue(value, "attachment")} />
                    </div>
                    <ButtonDialogAction onClick={submit} isAccept text={submitButtonText} />
                </div>
            </DialogActions>
        </>
    );
};

export default Form;
